import { useDispatch } from 'react-redux';
import { RootState, store } from '../store/store';
import Logger from '../common/logger';
import { bookingApiSlice } from '../api/booking/bookingApiSlice';
import { fetchBookingsFailure, fetchBookingsSuccess, initiateFetchBookings } from '../store/slices/bookingSlice';
import { useSelector } from 'react-redux';
import { toBookingsLoadError } from '../utils/bookingsLoadError';

const fetchBookingsCall = async (useCases: string, includeArchived: boolean) => {
    const result = await store.dispatch(
        bookingApiSlice.endpoints.getBookingList.initiate(
            { useCase: useCases, includeArchived },
            { forceRefetch: true },
        ),
    );

    if ('error' in result) {
        // eslint-disable-next-line no-console
        console.error('Error in fetchBookingsCall:', result.error);
        throw result.error;
    }

    return result;
};

export const useFetchBooking = (useCases: string[], includeArchived = false) => {
    const dispatch = useDispatch();
    const config = useSelector(
        (state: RootState) => state.authentication.config,
    );
    const isReady = config?.services !== undefined;
    // const useCase = config?.services?.includes('room-rental') ? 'apartment' : 'rental';

    const fetchBookings = async () => {
        if (!isReady) {
            // eslint-disable-next-line no-console
            console.log('fetchBookings called before config.services is ready');
            return;
        }

        try {

            dispatch(initiateFetchBookings());

            // eslint-disable-next-line no-console
            console.log('Fetching Orders');

            // dispatch(fetchBookings({}));
            let orders;
      
            const response = await fetchBookingsCall(useCases.join(','), includeArchived);
    
            if (response) {
                orders = response.data;
            }
            if (orders) {
                const result = {
                    bookings: orders,
                    totalRows: orders.length,
                };
                dispatch(fetchBookingsSuccess(result));
            }
            return orders;
        } catch (error) {
            Logger('fetchOrders').error(error);
            dispatch(fetchBookingsFailure(toBookingsLoadError(error)));
        }
    };

    return fetchBookings;
};
